import { useController, useFormContext } from 'react-hook-form'
import { Button, TextField, Typography } from '@mui/material'

import { EMAIL_REGEX } from 'common/constant'
import Loading from 'components/Loading'
import { useCompany } from 'utils/company'

interface LoginPageProps {
  onNext: () => void
}

export default function LoginPage({ onNext }: LoginPageProps): JSX.Element {
  const { control } = useFormContext()
  const { isFetched } = useCompany()
  const {
    field,
    fieldState: { error },
  } = useController({
    control,
    name: 'email',
    rules: {
      required: 'Email is required',
      pattern: {
        value: EMAIL_REGEX,
        message: 'Email is not valid',
      },
    },
  })

  if (!isFetched) {
    return <Loading />
  }

  return (
    <>
      <Typography variant="h4" align="center">
        Sign In
      </Typography>
      <TextField
        type="email"
        label="Email Address"
        error={error !== undefined}
        helperText={error?.message}
        {...field}
      />
      <Button type="button" variant="contained" onClick={onNext}>
        Sign In With Email
      </Button>
    </>
  )
}
